export const roles = {
  admin: "admin",
  supervisor: "supervisor",
  staff: "staff",
};
